<script lang="ts" module>
import { tv, type VariantProps } from "tailwind-variants";

export const separatorVariants = tv({
  base: "bg-border shrink-0",
  variants: {
    orientation: {
      horizontal: "h-px w-full",
      vertical: "min-h-full w-px",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export type SeparatorOrientation = VariantProps<
  typeof separatorVariants
>["orientation"];
</script>

<script lang="ts">
import { cn, type WithElementRef } from "$lib/utils.ts";
import type { HTMLAttributes } from "svelte/elements";

let {
  ref = $bindable(null),
  class: className,
  orientation = "horizontal",
  decorative = true,
  "data-slot": dataSlot = "separator",
  ...restProps
}: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
  orientation?: SeparatorOrientation;
  decorative?: boolean;
} = $props();
</script>

<div
  bind:this={ref}
  data-slot={dataSlot}
  role={decorative ? "none" : "separator"}
  aria-orientation={decorative ? undefined : orientation}
  class={cn(separatorVariants({ orientation }), className)}
  {...restProps}
></div>
